import HttpClient from "./index";

class UsersApi extends HttpClient {
  constructor(token = null) {
    super(process.env.REACT_APP_APIBASE, token);
  }
  async getUsers(data) {
    return await this.instance.get(
      `/user?page=${data.page}&limit=${data.limit}&search=${data.q}`
    );
  }
  async getAllUsers(data) {
    return await this.instance.get(`/user/all?search=${data.q}`);
  }
  async getUserById(id) {
    return await this.instance.get(`/user/${id}`);
  }
  async removeUser(data) {
    return await this.instance.delete(`/user/${data.id}`);
  }
  async updateUser(id, data) {
    return await this.instance.put(`/user/edit-user/${id}`, data);
  }
  async addUser(data) {
    return await this.instance.post(`/user/add-user`, data);
  }

  /* Attendance Apis */
  async postAttendance(data) {
    return await this.instance.post(`/attendance/add-attendance`, data);
  }
  async getAttendance(data) {
    return await this.instance.get(`/attendance?id=${data?.id}&date=${data?.date}`);
  }
}

export default UsersApi;
